import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpContractingServiceFieldConverter
     * @memberof app
     *
     * @restrict A
     *
     * @description
     * Works in conjunction with the label that will be passed to the directive.
     *
     * @example
     *
     * <input class="form-control" type="text"
     *        ng-model="servicesCtrl.contractingService.fields[$index]" name="{{field}}"
     *        pkp-contracting-service-field-converter="field">
     *
     * @author flzemke.btc
     */
    angular
        .module('app')
        .directive(
            'pkpContractingServiceFieldConverter',
            pkpContractingServiceFieldConverter
        );

    function pkpContractingServiceFieldConverter() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            var label = scope.$eval(attr.pkpContractingServiceFieldConverter);

            ngModelCtrl.$parsers.push(convertToModelValue);
            ngModelCtrl.$formatters.push(convertToViewValue);

            /**
             *
             * @param viewValue
             * @returns {{label: string, value: string}}
             */
            function convertToModelValue(viewValue) {
                return {
                    label: label,
                    value: viewValue
                };
            }

            /**
             *
             * @param modelValue
             * @returns {string|null}
             */
            function convertToViewValue(modelValue) {
                return !modelValue ? null : modelValue.value;
            }
        }
    }
})();
